import * as yup from "yup";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { HTTP_ENDPOINTS, QUERY_KEYS } from "../../consts/api";
import { http } from "../../services/HttpService";

const requestSchema = yup.object({
  clientId: yup.number().required(),
});

export function useFirePatientMutation({
  onError,
  onMutate,
  onSettled,
  onSuccess,
}) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (dto) => {
      const req = requestSchema.validateSync(dto, { strict: true });
      return http.put(HTTP_ENDPOINTS.patient.fire(req.clientId));
    },
    onMutate: () => {
      onMutate?.();
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [QUERY_KEYS.client],
      });
      onSuccess?.();
    },
    onError: () => {
      onError?.();
    },
    onSettled: () => {
      onSettled?.();
    },
  });
}
